import ArticleSlider from './ArticleSlider';
export default ArticleSlider;